module.exports = __webpack_public_path__ + "img/D201910_micro.cb250d30.jpg";